import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const PACKAGES = {
  starter: { name: '스타터', count: 11, priceLabel: '550원' },
  regular: { name: '레귤러', count: 58, priceLabel: '2,500원' },
  pro: { name: '프로', count: 120, priceLabel: '4,900원' },
};

const METHODS = {
  toss: '토스페이',
  kakao: '카카오페이',
};

export default function PaymentSuccessPage({ fetchCredits }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');

  const pkgId = searchParams.get('pkg');
  const methodId = searchParams.get('method');
  const userId = searchParams.get('userId');
  const orderId = searchParams.get('orderId');
  const pkg = PACKAGES[pkgId];
  const methodName = METHODS[methodId] || methodId;

  useEffect(() => {
    const processPayment = async () => {
      if (!userId || !pkg || !orderId) {
        setStatus('error');
        return;
      }
      try {
        // 서버에서 실제 결제 여부·금액을 검증한 뒤 말풍선을 지급한다.
        const res = await fetch('/api/payment-verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ paymentId: orderId, pkg: pkgId, userId }),
        });
        if (!res.ok) {
          setStatus('error');
          return;
        }

        if (fetchCredits) fetchCredits(userId);
        setStatus('success');
      } catch (error) {
        setStatus('error');
      }
    };

    processPayment();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (status === 'loading') return (
    <div style={{ minHeight: '100vh', background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Mono', monospace" }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <span style={{ width: 24, height: 24, border: '2px solid #e0e0e0', borderTopColor: '#111111', borderRadius: '50%', display: 'inline-block', animation: 'spin .7s linear infinite' }} />
        <span style={{ fontSize: 15, color: '#888888' }}>결제 처리 중이에요...</span>
      </div>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  if (status === 'error') return (
    <div style={{ minHeight: '100vh', background: '#ffffff', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Mono', monospace", padding: '32px 16px', gap: 12 }}>
        <div style={{ fontSize: 40 }}>!</div>
        <div style={{ fontSize: 16, fontWeight: 600, color: '#111111' }}>결제 처리 중 오류가 났어요</div>
        <div style={{ fontSize: 15, color: '#888888', textAlign: 'center', lineHeight: 1.7 }}>마이페이지 → 문의하기 → 오류 문의로<br/>알려주시면 빠르게 처리해드릴게요.</div>
        <button onClick={() => navigate('/my')}
          style={{ marginTop: 8, background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '12px 32px', fontSize: 15, cursor: 'pointer', fontFamily: "'DM Mono', monospace" }}>
          마이페이지로 이동
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f0f0f0', display: 'flex', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 430, background: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column', fontFamily: "'DM Mono', monospace" }}>
        <div style={{ background: '#ffffff', borderBottom: '1px solid #111111', height: 52, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <span style={{ fontSize: 15, fontWeight: 600, color: '#111111', letterSpacing: 1 }}>결제 완료</span>
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 16px', gap: 12 }}>
          <div style={{ width: 52, height: 52, borderRadius: '50%', background: '#111111', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff', fontSize: 22 }}>✓</div>
          <div style={{ fontSize: 16, fontWeight: 600, color: '#111111', marginTop: 4 }}>결제가 완료됐어요!</div>
          <div style={{ fontSize: 15, color: '#888888', textAlign: 'center', lineHeight: 1.7 }}>말풍선이 즉시 지급됐어요.<br/>마음껏 변환해보세요 :)</div>

          <div style={{ width: '100%', background: '#f5f5f5', borderRadius: 12, padding: 14, display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
            {[
              ['패키지', pkg?.name],
              ['지급 말풍선', `${pkg?.count}개`],
              ['결제수단', methodName],
            ].map(([k, v]) => (
              <div key={k} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, color: '#555555' }}>
                <span>{k}</span><span>{v}</span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 700, color: '#111111', borderTop: '1px solid #e0e0e0', paddingTop: 8, marginTop: 2 }}>
              <span>결제 금액</span><span>{pkg?.priceLabel}</span>
            </div>
          </div>

          <div style={{ width: '100%', background: '#f5f5f5', border: '1px solid #e0e0e0', borderRadius: 12, padding: '10px 12px' }}>
            <div style={{ fontSize: 13, color: '#555555', lineHeight: 1.7, display: 'flex', gap: 5 }}>
              <span style={{ color: '#888888', flexShrink: 0 }}>·</span>
              <span>레귤러/프로는 구매 후 <strong>7일 이내 미사용 시</strong> 환불 가능합니다. 마이페이지 → 문의하기 → 환불 요청에서 신청해주세요.</span>
            </div>
          </div>

          <button onClick={() => navigate('/')}
            style={{ width: '100%', background: '#111111', color: '#ffffff', border: 'none', borderRadius: 8, padding: '15px 20px', fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: "'DM Mono', monospace", marginTop: 4 }}>
            변환하러 가기
          </button>
        </div>
      </div>
    </div>
  );
}